import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Image,
  StyleSheet,
  KeyboardAvoidingView,
  Platform,
  Dimensions,
  PixelRatio,
  Modal,
  ActivityIndicator,
} from "react-native";
import meezalogo from "../../../assets/me_red.png"; //meeza_icon
import { useNavigation } from "@react-navigation/native";
import axios from "../../api/axios";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import Colours from "../../utils/Colours";

const { width, height } = Dimensions.get("window");

const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const PhoneNumberScreen = ({}) => {
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigation = useNavigation();

  const handleProceed = async () => {
    // 1. Remove everything that isn't a number (removes spaces, +, dashes)
    let cleaned = phoneNumber.replace(/\D/g, "");

    // 2. Remove ANY number of leading zeros (0, 00, 000...)
    cleaned = cleaned.replace(/^0+/, "");

    // 3. Remove leading 234 if it's now at the front
    if (cleaned.startsWith("234")) {
      cleaned = cleaned.slice(3);
    }

    // 4. Remove leading zero AGAIN (in case it was 234081...)
    cleaned = cleaned.replace(/^0+/, "");

    // Validation check
    if (cleaned.length !== 10) {
      // Show error...
      //console.log("number error");
      setErrorMessage("You might have entered a wrong number");
      setIsErrorCompVisible(true);
      return;
    }

    // 3. Final standardized format
    const finalPhoneNumber = `234${cleaned}`;

    //console.log("Input:", phoneNumber);
    //console.log("Cleaned (local):", cleaned);
    //console.log("Final (International):", finalPhoneNumber);

    //return;

    //  const finalPhoneNumber = `234${formattedNumber}`;

    // 3. Send to Backend
    try {
      setIsLoading(true);
      const response = await axios.post("/phoneSearch/phoneSearch", {
        phoneNumber: finalPhoneNumber,
      });

      // Handle your backend 'action' responses (NAVIGATE_TO_LOGIN, etc.)
      handleBackendResponse(response.data);
    } catch (error) {
      console.error("Error searching phone:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackendResponse = (data) => {
    const { success, action, message, phoneNumber } = data;

    switch (action) {
      case "VERIFY_OTP":
        // The "Anonymized" user path: code sent to WhatsApp
        // Move to the OTP input screen
        //console.log("Hereerer");
        navigation.navigate("otp_page", {
          whatsappNumber: phoneNumber,
          mode: "userSearch",
        });
        break;

      case "NAVIGATE_TO_LOGIN":
        // Full account exists (Email + Password)
        // Move to the password input screen
        //console.log("full here");

        // navigation.navigate("log_in", {
        //   phoneNumber: phoneNumber,
        // });
        navigation.navigate("sign_up", {
          mode: "complete_user",
          phoneNumber: phoneNumber,
        });
        break;

      case "NAVIGATE_TO_SIGNUP":
        // No user found at all
        // Move to the initial signup/onboarding screen
        //console.log("test here");

        navigation.navigate("sign_up", {
          phoneNumber: phoneNumber,
        });

        break;

      default:
        // Fallback for unexpected actions or errors
        setIsErrorCompVisible(true);
        setErrorMessage(message || "Something went wrong. Please try again.");
        break;
    }
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      style={styles.container}
    >
      <View style={styles.innerContainer}>
        {/* Top/Center Section: Logo and Form */}
        <View style={styles.mainContent}>
          <View style={styles.logoContainer}>
            <View
              style={{
                width: dynamicSize(80),
                height: dynamicSize(80),
                borderRadius: dynamicSize(15),
                overflow: "hidden",
                marginBottom: dynamicSpacing(20),
              }}
            >
              <Image source={meezalogo} style={styles.logoImage} />
            </View>

            <Text style={styles.title}>Welcome to Meeza</Text>
            <Text style={styles.subtitle}>Enter your WhatsApp number to continue</Text>
          </View>

          <View style={styles.formContainer}>
            <View style={styles.inputWrapper}>
              <Text style={styles.prefix}>+234</Text>
              <TextInput
                style={styles.input}
                placeholder="801 234 5678"
                placeholderTextColor="#9E9E9E"
                keyboardType="phone-pad"
                value={phoneNumber}
                // This regex replaces any non-digit character with an empty string
                onChangeText={(text) => setPhoneNumber(text.replace(/[^0-9]/g, ""))}
                maxLength={11}
              />
            </View>

            <TouchableOpacity
              style={[styles.button, !phoneNumber && styles.buttonDisabled]}
              onPress={handleProceed}
              disabled={!phoneNumber}
            >
              {isLoading ? (
                <ActivityIndicator color={"white"} />
              ) : (
                <Text style={styles.buttonText}>Proceed</Text>
              )}
            </TouchableOpacity>
          </View>
        </View>

        {/* Bottom Section: Login Instead Link */}
        <View style={styles.footer}>
          <Text style={styles.footerText}>Already have an account? </Text>
          <TouchableOpacity onPress={() => navigation.navigate("log_in")}>
            <Text style={styles.loginLink}>Login instead</Text>
          </TouchableOpacity>
        </View>
      </View>
      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  innerContainer: {
    flex: 1,
    paddingHorizontal: dynamicSpacing(25),
    paddingBottom: dynamicSpacing(40), // Space for the footer link
  },
  mainContent: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  logoContainer: {
    alignItems: "center",
    marginBottom: dynamicSpacing(40),
  },
  logoImage: {
    width: dynamicSize(80),
    height: dynamicSize(80),
    borderRadius: dynamicSize(20),
    overflow: "hidden", // Fixes PWA border radius
    marginBottom: dynamicSpacing(15),
  },
  title: {
    fontSize: dynamicFontSize(24),
    fontFamily: "Sen-Bold",
    color: "#1A1A1A",
    marginBottom: dynamicSpacing(8),
  },
  subtitle: {
    fontSize: dynamicFontSize(14),
    color: "#666",
    textAlign: "center",
    fontFamily: "Sen-Regular",
  },
  formContainer: {
    width: "100%",
    maxWidth: 400,
  },
  inputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F5F5F5",
    borderRadius: dynamicSize(12),
    paddingHorizontal: dynamicSpacing(15),
    height: dynamicSize(55),
    marginBottom: dynamicSpacing(20),
    borderWidth: 1,
    borderColor: "#E0E0E0",
  },
  prefix: {
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
    color: "#1A1A1A",
    marginRight: dynamicSpacing(10),
  },
  input: {
    flex: 1,
    fontSize: dynamicFontSize(16),
    color: "#1A1A1A",
    fontFamily: "Sen-Medium",
    // For PWA:
    ...(Platform.OS === "web" && { outlineStyle: "none" }),
  },
  button: {
    backgroundColor: "#000",
    height: dynamicSize(55),
    borderRadius: dynamicSize(12),
    justifyContent: "center",
    alignItems: "center",
  },
  buttonText: {
    color: "#FFFFFF",
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
  },
  buttonDisabled: {
    backgroundColor: "#CCCCCC",
  },
  // --- FOOTER STYLES ---
  footer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: dynamicSpacing(20),
  },
  footerText: {
    fontSize: dynamicFontSize(14),
    color: "#666",
    fontFamily: "Sen-Regular",
  },
  loginLink: {
    fontSize: dynamicFontSize(14),
    color: "#000",
    fontFamily: "Sen-Bold",
    textDecorationLine: "underline",
  },
});

export default PhoneNumberScreen;
